import i18n, { type Resource } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import resources from '@/app/i18n/resources'

const LOCALE_STORAGE_KEY = 'floodnet.locale'
export const SUPPORTED_LOCALES = ['en', 'es'] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number];

const i18nResources: Resource = resources

if (!i18n.isInitialized) {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: i18nResources,
      fallbackLng: 'en',
      supportedLngs: SUPPORTED_LOCALES,
      defaultNS: 'translation',
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: LOCALE_STORAGE_KEY,
        caches: ['localStorage'],
      },
    })
}

export default i18n;

// export function I18nProvider({ children }: { children: React.ReactNode }) {
//   return <>{children}</>
// }
